import React, { Component } from 'react';

import { editWikiCreateCongig, getWikiCreateCongig } from '../wiki_action';




import {
  Tag,
  Button,
  Modal,
  Card,
  message,
  Input,
  Row,
  Col,
  Alert,
  Dropdown,
  Menu,
  Layout,
  Popconfirm,
  Collapse,
  Switch,
  Typography,
  Avatar,
  List,
  Select,
} from 'antd';

import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import Validator from 'validator';
import isEmpty from 'lodash/isEmpty';
import MemberSelect from 'components/common/memberSelect';
import ConnectConfluence from '../confluenceConnect';
const { Option } = Select;
const { Panel } = Collapse;
// import bcrypt from 'bcryptjs';
const Jira_skill_id = localStorage.getItem('Jira_skill_id');
const { SubMenu } = Menu;
const { Content } = Layout;
const { Text } = Typography;
class JiraConfiguration extends Component {
  constructor(props) {
    super(props);
    this.formRef = React.createRef();
    this.state = {
      loading: false,
      currentMemberSelected: [],
    };
    this.onMemberSelect = this.onMemberSelect.bind(this);
  }

  onMemberSelect(users) {
    this.setState({ currentMemberSelected: users });
  }
  addCreateUsers = () => {
    let allowedUsers = [
      ...this.props.wikiCreateConfig.allowedUsers.map((u) =>
        u.user_id ? u.user_id : u
      ),
      ...this.state.currentMemberSelected,
    ];

    this.updateWikiCreateConfig({ allowedUsers });
  };

  deleteCreateUser = (user_id) => {
    let allowedUsers = this.props.wikiCreateConfig.allowedUsers.filter((id) =>
      id && id.user_id
        ? id.user_id.toString() !== user_id.toString()
        : id.toString() !== user_id.toString()
    );

    this.updateWikiCreateConfig({ allowedUsers });
  };
  onChangeSwitch = (val) => {
    this.updateWikiCreateConfig({ isAllowed: val });
  };

  adminDeletePopconfirmTitle = (name) => {
    return `This action will remove Create privileges for ${name}. Are you sure?`;
  };
  async componentDidMount() {
    this.setState({ loading: true });
    await this.props.getWikiCreateCongig(this.props.match.params.wId);

    this.setState({ loading: false });
  }
  updateWikiCreateConfig = (data) => {
    let updateData = data;
    this.props.editWikiCreateCongig(this.props.match.params.wId, updateData);
    this.setState({ currentMemberSelected: [] });
  };
  onChangeChannel = (event, value) => {
    //value gets all the props
    //event gets the value props
    this.setState({
      selectedChannel: event,
      selectedChannelName: value.props.children,
    });
  };

  // Delete token Start
  deleteToken = (allowed) => {
    const { skill } = this.props;

    if (allowed) {
      let skillId =
        skill && skill.skill_metadata ? skill.skill_metadata._id : skill._id;
      let wId =
        skill && skill.skill_metadata
          ? skill.skill_metadata.workspace_id
          : skill.workspace_id;
      this.setState({ loading: true });
      this.props
        .updateSkill(
          skillId,
          wId,
          { 'metadata.token_obj': null },
          this.props.currentSkill
        )
        .then((res) => {
          if (res.data.success) {
            this.setState({ loading: false });
            message.success('Token deleted');
          }
        });
    } else {
      message.error(
        'You are not having permission to delete token.Contact your jira admin.'
      );
    }
  };
  // Delete token End

  doNotShowModal = () => {
    this.setState({
      getToken: false,
    });
  };

  getUserName = (event) => {
    // if(event.target.value){
    this.setState({
      userName: event.target.value,
    });
    // }
  };

  getUserToken = (event) => {
    // console.log("event--->",event.target.value)
    // if(event.target.value){
    this.setState({
      userToken: event.target.value,
    });
    // }
  };

  submitTokenData = () => {
    this.invokeChildMethod();
  };

  // connectUrl = () => {
  //   this.props.getSkillConnectUrl(this.props.skill.name, this.props.workspace_id)
  //     .then(res => {
  //       if (res.data.success) {
  //         var url = res.data.url;
  //         window.open(url, "_blank");
  //         let data = {
  //           name: this.props.skill.name,
  //           connectUserId: localStorage.getItem("trooprUserId")
  //         };
  //         let wId = this.props.workspace_id;
  //         this.props.setJiraConnectId(wId, data);
  //       }
  //     });
  // };

  // addGridToken=async(id)=>{

  // //  axios.post('/bot/api/'+this.props.match.params.wId+'/jira_grid_token/'+this.props.skill._id+"?token_id="+id).then(res=>{
  //  axios.post('/bot/api/w/'+this.props.match.params.wId+'/jira/jira_grid_token/'+this.props.skill._id+"?token_id="+id).then(res=>{
  //    if(res.data.skill){
  // this.props.setSkill(res.data.skill)
  // this.props.setCurrentSkill(res.data.skill)
  // this.props.updateAssisantSkills(res.data.skill)
  //    }else{
  //     message.error("There was a error connecting Confluence.");
  //    }

  //  })
  //  }

  // Menu End

  openConnectModal = () => {
    this.setState({ newConnectionModal: true });
  };

  wikiOuathPage = (type) => {
    // this.setState()=>{

    // }
    // console.log(this.props)
    this.props.history.push(
      `/${this.props.match.params.wId}/wikiOuath/${this.props.match.params.skill_id}/0?connection_type=${type}`
    );
  };

  handleCancel = () => {
    this.setState({ newConnectionModal: false });
    if (this.formRef.current) {
      this.formRef.current.resetFields();
    }
  };



  // Confluence New Connection End
  acceptMethods(invokeChildMethod) {
    this.invokeChildMethod = invokeChildMethod;
  }
  urlModalToggle = () => {
    this.setState({ urlModal: !this.state.urlModal });
  };

  onChange = (e) => {
    this.setState({ [e.target.name]: e.target.value });
  };
  submitNewUrl = () => {
    if (this.state.domain_url) {
      let domain_url = this.state.domain_url;
      domain_url =
        domain_url[domain_url.length - 1] == '/'
          ? domain_url.substring(0, domain_url.length - 1)
          : domain_url;
      this.setState({ domain_url: this.state.domain_url.trim() });

      let obj = { 'metadata.domain_url': domain_url };
      let { skill } = this.props;
      let skillId =
        skill && skill.skill_metadata ? skill.skill_metadata._id : skill._id;
      let wId =
        skill && skill.skill_metadata
          ? skill.skill_metadata.workspace_id
          : skill.workspace_id;
      this.props
        .updateSkill(skillId, wId, obj, this.props.currentSkill)
        .then((res) => {
          if (res.data.success) {
            this.setState({ urlModal: !this.state.urlModal });
            message.success(
              'Confluence Base url updated to :' + this.state.domain_url
            );
          }
        });
    } else {
      message.error('Confluence Base url cannot be empty');
    }
  };

  getInitials(string) {
    if (string) {
      let nameArr = string
        .trim()
        .replace(/\s+/g, ' ') //remove extra spaces
        .split(' ');

      if (nameArr.length > 1)
        return (nameArr[0][0] + nameArr[1][0]).toUpperCase();
      else return nameArr[0].slice(0, 2).toUpperCase();
    } else return '';
  }

  render() {
    const { members, user, isUserPrivileged, wikiCreateConfig } = this.props;
    let createUsers =
      wikiCreateConfig && wikiCreateConfig.allowedUsers
        ? wikiCreateConfig.allowedUsers
        : [];
    let createUserssList = createUsers;
    // createUserssList

    // let memberOptions = [];
    // members.forEach((member) => {
    //   let isCreateUser = createUsers.find(
    //     (id) => member.user_id?id.toString() === member.user_id._id.toString():id.toString() === member.toString()
    //   );

    //   if (isCreateUser) {
    //     createUserssList.push(member);
    //   } else {
    //     let option = (
    //       <Option key={member.user_id._id} value={member.user_id._id}>
    //         {member.user_id.displayName || member.user_id.name}
    //       </Option>
    //     );
    //     memberOptions.push(option);
    //   }
    // });
    const col_span = 24;

    return (
      <Col span={col_span}>
        <Card
          style={{ width: '100%' }}
          loading={this.state.loading}
          title={'Confluence Create'}
          size='small'
          // bodyStyle={{ overflow: "hidden" }}
          extra={
            <div
              onClick={(e) => {
                e.stopPropagation();
              }}
            >
              <Switch
                onChange={this.onChangeSwitch}
                disabled={!isUserPrivileged}
                checked={
                  this.props.wikiCreateConfig &&
                    this.props.wikiCreateConfig.isAllowed
                    ? true
                    : false
                }
              // checked={this.state.isUnfurlLink}
              />
            </div>
          }
        >
          <div
            style={{
              width: '100%',
              display: 'inline-flex',
              'justify-content': 'space-between',
              marginBottom: '20px',
              padding: '8px 16px',
            }}
          >
            {/* <div style={{ width: "85%","display": "inline-flex","justify-content": "space-between"}}> */}
            <MemberSelect
              showSearch
              disabled={
                !isUserPrivileged ||
                !(
                  this.props.wikiCreateConfig &&
                  this.props.wikiCreateConfig.isAllowed
                )
              }
              style={{ width: '85%' }}
              allowClear={true}
              // defaultValue=""
              placeholder='Type member name'
              dropdownClassName='sidebar_dropdown'
              // value={this.state.memberList._id && this.state.memberList.name}
              value={this.state.currentMemberSelected}
              mode='multiple'
              onChange={this.onMemberSelect}
              rejectedUsers={wikiCreateConfig && wikiCreateConfig.allowedUsers}
            // onChange={this.onMemberChange}
            // filterOption={(input, option) =>
            //   option.props.children
            //     .toLowerCase()
            //     .indexOf(input.toLowerCase()) >= 0
            // }
            />
            {/* {memberOptions}
            </Select> */}
            <Button
              onClick={() => this.addCreateUsers()}
              disabled={this.state.currentMemberSelected.length === 0}
            >
              {' '}
              Add Users
            </Button>
            {/* </div> */}
          </div>
          <List
            size='small'
            pagination={{ pageSize: 10 }}
            itemLayout='horizontal'
            // loading={true}
            dataSource={createUserssList}
            renderItem={(item) => (
              <List.Item
                actions={[
                  isUserPrivileged && (
                    <Popconfirm
                      title={() =>
                        this.adminDeletePopconfirmTitle(
                          item.displayName || item.name
                        )
                      }
                      onConfirm={() =>
                        this.deleteCreateUser(item.user_id._id || item.user_id)
                      }
                      // onCancel={cancel}
                      okText='Yes'
                      cancelText='No'
                    >
                      {/* <DeleteOutlined/> */}
                      {/* <a href='#'>Remove</a> */}
                      <Button danger type='link'>
                        Remove
                      </Button>
                    </Popconfirm>
                  ),
                ]}
              >
                <List.Item.Meta
                  avatar={
                    <Avatar src={item.profilePicUrl}>
                      {this.getInitials(
                        item.user_id
                          ? item.user_id.displayName ||
                          item.user_id.name ||
                          item.displayName ||
                          item.name
                          : item
                      )}
                    </Avatar>
                  }
                  title={
                    item.user_id
                      ? item.user_id.displayName ||
                      item.user_id.name ||
                      item.displayName ||
                      item.name
                      : item
                  }
                  description={item.email}
                />
              </List.Item>
            )}
          />
        </Card>
      </Col>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    wikiCreateConfig: state.wiki.createConfig,
  };
};

export default withRouter(
  connect(mapStateToProps, {
    editWikiCreateCongig,
    getWikiCreateCongig,
  })(JiraConfiguration)
);
